import script from "./MovimientoDrasticoAlertas.vue?vue&type=script&setup=true&lang=js"
export * from "./MovimientoDrasticoAlertas.vue?vue&type=script&setup=true&lang=js"

import "./MovimientoDrasticoAlertas.vue?vue&type=style&index=0&id=2e5fb788&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e5fb788"]])

export default __exports__